import { useRef, useState, useEffect, useCallback } from 'react';
import debounce from 'lodash/debounce';
import { useLayoutEffect } from './useLayoutEffect';
export function useOverflow() {
  const contentRef = useRef();
  const scrollerRef = useRef();
  const observerRef = useRef();
  const [state, setState] = useState({
    hasOverflowTop: false,
    hasOverflowRight: false,
    hasOverflowBottom: false,
    hasOverflowLeft: false
  });
  const updateScroll = () => {
    if (!(scrollerRef.current instanceof HTMLElement)) return;
    const {
      scrollHeight,
      clientHeight,
      scrollTop,
      scrollWidth,
      clientWidth,
      scrollLeft
    } = scrollerRef.current;
    const hasOverflowTop = scrollTop > 0;
    const hasOverflowBottom = scrollHeight > clientHeight + scrollTop;
    const hasOverflowLeft = scrollLeft > 0;
    const hasOverflowRight = scrollWidth > clientWidth + scrollLeft;
    setState({
      hasOverflowTop,
      hasOverflowRight,
      hasOverflowBottom,
      hasOverflowLeft
    });
  };
  const handleScroll = useCallback(debounce(() => {
    updateScroll();
  }, 166), []);
  useEffect(() => () => handleScroll.cancel(), []);
  useLayoutEffect(() => {
    if (typeof ResizeObserver !== 'function') {
      return;
    }
    observerRef.current = new ResizeObserver(() => {
      updateScroll();
    });
    const observer = observerRef.current;
    const scroller = scrollerRef.current;
    const content = contentRef.current;
    if (!(scroller instanceof HTMLElement) || !(content instanceof HTMLElement)) {
      return;
    }
    observer.observe(scroller);
    observer.observe(content);
    return () => {
      if (observerRef.current) observerRef.current.disconnect();
    };
  }, []);
  return {
    ...state,
    contentRef,
    scrollerRef,
    scrollerProps: {
      onScroll: handleScroll
    }
  };
}